import React from 'react';

import { Wrapper } from './atoms/Wrapper';
import { InfoWrapper } from './atoms/InfoWrapper';
import { InfoTextWrapper } from './atoms/InfoTextWrapper';
import { InfoTitle } from './atoms/InfoTitle';
import { InfoText } from './atoms/InfoText';
import { StreetIcon } from './atoms/StreetIcon';
import { AddressIcon } from './atoms/AddressIcon';
import { EmailIcon } from './atoms/EmailIcon';
import { MapsRouter } from './atoms/MapsRouter';
import { MapsWrapper } from './atoms/MapsWrapper';
import { contentHeight } from './atoms/variables';

interface Props {
    street: string;
    address: string;
    email: string;
}
export const InfoMaps: React.FC<Props> = ({ street, address, email }) => (
    <Wrapper>
        <InfoWrapper>
            <InfoTextWrapper>
                <div>
                    <InfoTitle>Developers.nl</InfoTitle>
                    <InfoText>
                        <StreetIcon /> {street}
                    </InfoText>
                    <InfoText>
                        <AddressIcon /> {address}
                    </InfoText>
                    <InfoText>
                        <EmailIcon /> {email}
                    </InfoText>
                </div>
            </InfoTextWrapper>
        </InfoWrapper>
        <MapsRouter>
            <MapsWrapper>
                <iframe
                    width="100%"
                    height={contentHeight}
                    id="gmap_canvas"
                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2462.099888447511!2d4.523577915373886!3d51.89564119006351!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x47c4349a9c8ff9d3%3A0x99e7a7fdc7d5f995!2sDevelopers.nl!5e0!3m2!1snl!2snl!4v1561027925630!5m2!1snl!2snl"
                    frameBorder="0"
                    scrolling="no"
                    marginHeight={0}
                    marginWidth={0}
                />
            </MapsWrapper>
        </MapsRouter>
    </Wrapper>
);
